export { useGrantAccessPopupCopy } from './useGrantAccessPopupCopy.hook';
